import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import axios from 'src/utils/axios';
import { safeRequestParam } from 'src/utils/Common';

function UrunSearch({ setModel, value, searchParam }) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;
    const [search, setSearch] = React.useState('');
    const [fromBarkod, setFromBarkod] = React.useState(false);

    React.useEffect(() => {
        // let active = true;
        var Param = search;
        Param = Param.trim();

        if (Param.length > 0 && (open || fromBarkod)) {
            axios.get('/GetArtemisModels/' + safeRequestParam(Param).toString().toLocaleLowerCase('tr-TR'))
                .then(res => {
                    // if (active || fromBarkod) {
                    const response = res.data;
                    if (response.length > 0) {
                        fromBarkod ? updateModel(response[0]) : setOptions(response);
                    } else {
                        fromBarkod ? updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: '' }) : setOptions([]);
                    }
                    // }
                }).catch(() => {
                    if (fromBarkod) {
                        updateModel({ ACIKLAMA: '', KUL_MODEL_KODU: Param });
                    }
                    setOptions([]);
                });
        }
        // return () => {
        //     active = false;
        // };
        // eslint-disable-next-line
    }, [search, open, loading, fromBarkod]);

    React.useEffect(() => {
        if (searchParam.length > 0) {
            setFromBarkod(true);
            setSearch(searchParam);
        }
    }, [searchParam]);

    const updateModel = model => {
        setModel(model);
        value.ACIKLAMA = model.ACIKLAMA;
        value.KUL_MODEL_KODU = model.KUL_MODEL_KODU;
        setFromBarkod(false);
    }

    return (
        <Autocomplete
            id="asynchronous-demo"
            open={open}
            value={value}
            autoFocus={false}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionLabel={(option) => { return option.KUL_MODEL_KODU ? (option.KUL_MODEL_KODU + ' - ' + option.ACIKLAMA) : '-' }}
            options={options}
            filterOptions={(options) => options}
            loading={loading}
            onChange={(event, newValue) => {
                if (newValue && newValue.ACIKLAMA) {
                    updateModel(newValue);
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    onChange={e => { setSearch(e.target.value) }}
                    variant="outlined"
                    helperText={value ? value.ACIKLAMA : ''}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export default UrunSearch;
